export default {
  methods: {
    userAccountStatusName(status){
      switch (status){
        case 0:
          return 'Cuenta no activada, correo no verificado';
        case 1:
          return 'Cuenta activada';
        case 2:
          return 'Usuario bloqueado';
        case 3:
          return 'Solicitud de cancelación de cuenta por el usuario';
        case 4:
          return 'Cuenta cancelada';
        default:
          return 'No definido';
      }
    },
    investorAccountStatusName(status){
      switch (status){
        case 0:
          return 'Inversionista registrado';
        case 1:
          return 'Correo verificado';
        case 2:
          return 'Verificado';
        case 3:
          return '12 meses sin invertir';
        case 4:
          return '6 meses sin invertir';
        case 5:
          return '3 meses sin invertir';
        case 6:
          return '1 mes sin invertir';
        case 7:
          return 'Menos de un mes de invertir';
        default:
          return 'No definido';
      }
    }
  }
}
